import { render, staticRenderFns } from "./step-2.vue?vue&type=template&id=45b22cc2&scoped=true&"
import script from "./step-2.vue?vue&type=script&lang=js&"
export * from "./step-2.vue?vue&type=script&lang=js&"
import style0 from "./step-2.vue?vue&type=style&index=0&id=45b22cc2&lang=scss&scoped=true&"
import style1 from "./step-2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b22cc2",
  null
  
)

export default component.exports